import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { FC } from "react";

import { AccountBillingFormValues } from ".";

interface InputFieldProps {
	form: ReturnType<typeof useFormik<AccountBillingFormValues>>;
	name: string;
	label: string;
	md?: number;
	placeholder?: string;
}

export const InputField: FC<InputFieldProps> = ({
	form,
	name,
	label,
	md = 6,
	placeholder = "",
}) => {
	const { errors, getFieldProps, touched } = form;

	return (
		<Grid
			size={{
				md: md,
				xs: 12,
			}}>
			<FormControl fullWidth>
				<TextField
					{...getFieldProps(name)}
					label={label}
					error={!!touched[name] && !!errors[name]}
					helperText={!!touched[name] && errors[name]}
					placeholder={placeholder}
				/>
			</FormControl>
		</Grid>
	);
};
